import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    pageLoader: {
        main: null
    },
    token: {
        access: null
    },
    collapse: false,
    isValueSet: false
}

export const utilsSlice = createSlice({
    name: 'utils',
    initialState,
    reducers: {
        setPageLoader: (state, { payload }) => {
            let { pageName, flag } = payload
            state.pageLoader[pageName] = flag
        },
        setAccessTokens: (state, { payload }) => {
            let { token } = payload
            state.token.access = token
        },
        setSidebarCollapse: (state, { payload }) => {
            state.collapse = payload
        },
        setIsValueSet: (state, { payload }) => {
            state.isValueSet = payload
        }
    },
})

// Action creators are generated for each case reducer function
export const { setPageLoader, setAccessTokens, setSidebarCollapse, setIsValueSet } = utilsSlice.actions

export default utilsSlice.reducer